import React from "react";

export default function DownloadIcon() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.85603 14.3218C9.87273 14.3432 9.89407 14.3604 9.91844 14.3723C9.9428 14.3842 9.96955 14.3903 9.99665 14.3903C10.0238 14.3903 10.0505 14.3842 10.0749 14.3723C10.0992 14.3604 10.1206 14.3432 10.1373 14.3218L12.6373 11.1589C12.7288 11.0428 12.6462 10.8709 12.4967 10.8709H10.8426V3.31737C10.8426 3.21915 10.7623 3.13879 10.6641 3.13879H9.32478C9.22656 3.13879 9.14621 3.21915 9.14621 3.31737V10.8687H7.49665C7.3471 10.8687 7.26451 11.0406 7.35603 11.1567L9.85603 14.3218ZM18.1663 13.5406H16.827C16.7288 13.5406 16.6484 13.6209 16.6484 13.7192V17.1567H3.34487V13.7192C3.34487 13.6209 3.26451 13.5406 3.16629 13.5406H1.82701C1.72879 13.5406 1.64844 13.6209 1.64844 13.7192V18.1388C1.64844 18.5339 1.96763 18.8531 2.36272 18.8531H17.6306C18.0257 18.8531 18.3449 18.5339 18.3449 18.1388V13.7192C18.3449 13.6209 18.2645 13.5406 18.1663 13.5406Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
